import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useAuthorization } from 'core/context';
import { verifyEmail } from 'core/api';
import { Spinner } from 'view/components/layout';
import { VerificationStatus } from './VerificationStatus';
import { useToast } from 'core/toast';

export const VerifyEmailPage : React.FunctionComponent = () => 
{
    const history = useHistory();
    const { setToastMessage } = useToast();
    const { isAuth } = useAuthorization();
    const [ status,    setStatus    ] = useState<boolean>(false);

    const parameters = window.location.search;
    const [ token, email ] = parameters
        .replace('?token=', ' ')
        .replace('&email=', ' ')
        .replace('&new_user=', '')
        .split(' ')
        .slice(1);

    // Query params `token` and `email` must be set
    if (token === null || email === null) 
    {
        history.push('/login');
    }

    useEffect(() =>
    {
        (async () =>
        {
            if (token !== null && email !== null)
            {
                const { success } = await verifyEmail({ email, token });
                if (success)
                {

                    setToastMessage('Email was successfully verified');
                    setStatus(success);
                }
                else 
                {
                    setToastMessage();
                    history.push('/login');
                }
            }
        })();
    }, []);

    useEffect(() => 
    {
        // User is logged in and has successfully verified
        if (status && isAuth) history.push('/dashboard');
    }, [ status, isAuth ]);

    if (status && !isAuth) return <VerificationStatus success={status} />;
    else return <Spinner css='position: absolute; padding-top: 50px;' />;
};